// if (!customElements.get('video-reviews-component')) {
//     customElements.define(
//       'video-reviews-component',
//       class VideoReviewsComponent extends HTMLElement {
//         constructor() {
//           super();
  
//           this.sliderInstance = false;
//           this.activeSlide = null;
//           this.activeVideo = null;
  
//           this.playRequestedIndex = null;
//           this.playRequestedManual = false;
//           this.pendingManualSound = false;
//           this.playToken = 0;
  
//           this.sectionId = this.dataset.sectionId;
//           this.section = this.closest(`.section-${this.sectionId}`);
  
//           this.items = this.querySelector('.video-reviews__items');
//           this.swiperEl = this.querySelector('.video-reviews__swiper');
//           this.slides = Array.from(this.querySelectorAll('.video-reviews__slide'));
//           this.videos = Array.from(this.querySelectorAll('.video-reviews__video'));
  
//           this.enableSlider = this.dataset.enableSlider === 'true';
//           this.autoplay = this.dataset.autoplay === 'true';
//           this.autoplaySound = this.dataset.autoplaySound === 'true';
//         }
  
//         connectedCallback() {
//           if (!this.section || !this.items) return;
  
//           this.bindVideoEvents();
//           this.bindUI();
  
//           if (!this.enableSlider) {
//             const firstSlide = this.slides[0];
//             if (firstSlide && this.autoplay) {
//               this.playSlide(firstSlide, { manual: false });
//             }
//             return;
//           }
  
//           this.selectors = {
//             nextEl: this.section.querySelector('.swiper-btn-next'),
//             prevEl: this.section.querySelector('.swiper-btn-prev'),
//           };
  
//           this.initSlider();
//         }
  
//         bindVideoEvents() {
//           this.slides.forEach((slide) => {
//             const video = slide.querySelector('.video-reviews__video');
//             if (!video) return;
  
//             // Keep UI in sync with real playback state.
//             video.addEventListener('play', () => {
//               slide.classList.add('is-playing');
//             });
  
//             video.addEventListener('pause', () => {
//               slide.classList.remove('is-playing');
//             });
//           });
//         }
  
//         bindUI() {
//           this.addEventListener('click', (event) => {
//             const soundBtn = event.target.closest('[data-action="toggle-sound"]');
//             if (soundBtn) {
//               const slide = soundBtn.closest('.video-reviews__slide');
//               if (!slide) return;
  
//               const video = slide.querySelector('.video-reviews__video');
//               if (!video) return;
  
//               // Ensure clicked slide is center first, then toggle sound.
//               if (this.sliderInstance && typeof this.sliderInstance.slider === 'object') {
//                 const index = this.getSlideIndex(slide);
//                 const isCurrentCenter = this.sliderInstance.slider.realIndex === index;
//                 if (!isCurrentCenter) {
//                   this.playRequestedIndex = index;
//                   this.playRequestedManual = true;
//                   this.sliderInstance.slider.slideToLoop(index);
//                   return;
//                 }
//               }
  
//               const nextMuted = !video.muted;
//               video.muted = nextMuted;
//               this.updateSoundButtonState(slide, video);
  
//               if (video.paused) {
//                 this.playSlide(slide, { manual: true });
//               }
//               return;
//             }
  
//             const playBtn = event.target.closest('[data-action="play"]');
//             if (!playBtn) return;
  
//             const slide = playBtn.closest('.video-reviews__slide');
//             if (!slide) return;
  
//             const index = this.getSlideIndex(slide);
//             if (Number.isNaN(index)) return;
  
//             // Any play click is a "manual play": enable sound when playback starts.
//             this.pendingManualSound = true;
  
//             if (!this.sliderInstance || typeof this.sliderInstance.slider !== 'object') {
//               this.playSlide(slide, { manual: true });
//               return;
//             }
  
//             const swiper = this.sliderInstance.slider;
//             const isCurrentCenter = typeof swiper.realIndex === 'number' && swiper.realIndex === index;
  
//             // If it's already the active/center slide, toggle play/pause.
//             if (isCurrentCenter) {
//               const video = this.activeVideo || slide.querySelector('.video-reviews__video');
//               if (!video) return;
  
//               if (video.paused) {
//                 const centerSlide = swiper.slides[swiper.activeIndex] || slide;
//                 this.playSlide(centerSlide, { manual: true });
//               } else {
//                 this.pauseVideo(video);
//               }
//               return;
//             }
  
//             // Click on side slide behaves like next/prev: move one step only.
//             this.playRequestedIndex = null;
//             this.playRequestedManual = true;
  
//             if (slide.classList.contains('swiper-slide-next')) {
//               swiper.slideNext();
//               return;
//             }
  
//             if (slide.classList.contains('swiper-slide-prev')) {
//               swiper.slidePrev();
//               return;
//             }
  
//             // Fallback when classes are not yet updated: infer direction by position.
//             const activeSlide = swiper.slides[swiper.activeIndex];
//             if (!activeSlide) {
//               swiper.slideToLoop(index);
//               return;
//             }
  
//             const activeRect = activeSlide.getBoundingClientRect();
//             const clickedRect = slide.getBoundingClientRect();
//             const activeCenter = activeRect.left + activeRect.width / 2;
//             const clickedCenter = clickedRect.left + clickedRect.width / 2;
  
//             if (clickedCenter > activeCenter) {
//               swiper.slideNext();
//             } else {
//               swiper.slidePrev();
//             }
//           });
//         }
  
//         initSlider() {
//           if (!window.FoxTheme?.Carousel || !window.FoxTheme?.Swiper?.Swiper) return;
  
//           const columnGap =
//             typeof window.FoxTheme?.utils?.getGridColumnGap === 'function' ? window.FoxTheme.utils.getGridColumnGap(this.items) : null;
//           const spaceBetween = columnGap?.desktop ? columnGap.desktop : 0;
  
//           this.items.classList.add('swiper-wrapper');
//           this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
  
//           const carouselContainer = this.swiperEl || this;
  
//           this.sliderInstance = new window.FoxTheme.Carousel(carouselContainer, {
//             slidesPerView: 'auto',
//             centeredSlides: true,
//             loop: true,
//             threshold: 2,
//             grabCursor: true,
//             allowTouchMove: true,
//             spaceBetween: spaceBetween,
//             watchSlidesProgress: true,
//             pagination: false,
//           });
  
//           this.sliderInstance.init();
//           const swiper = this.sliderInstance.slider;
  
//           const applySlideScale = () => {
//             if (!swiper?.slides) return;

//             swiper.slides.forEach((slide) => {
//               const progress = slide.progress || 0; // 0 = center, +/-1/2 etc.
//               const absProgress = Math.abs(progress);

//               let scale;
//               if (absProgress < 0.5) {
//                 scale = 1;
//               } else if (absProgress < 1.5) {
//                 scale = 0.9;
//               } else if (absProgress < 2.5) {
//                 scale = 0.85;
//               } else {
//                 scale = 0.8;
//               }

//               let translateX = 0;
//               if (absProgress > 1.5 && absProgress < 2.5) {
//                 translateX = progress < 0 ? -40 : 40;
//               } else if (absProgress > 0.5 && absProgress < 1.5) {
//                 translateX = progress < 0 ? -10 : 10;
//               }

//               // Swiper moves slides via wrapper transform; we only add subtle nudge + scale.
//               // slide.style.transform = `translateX(${translateX}px) scale(${scale})`;
//             });
//           };

//           swiper.on('progress', () => {
//             if (swiper.animating) return;
//             applySlideScale();
//           });

//           swiper.on('slideChangeTransitionEnd', () => {
//             this.handleSlideChange();
//             applySlideScale();
//           });
//           swiper.on('init', () => {
//             applySlideScale();
//             this.handleSlideChange(true);
//           });
  
//           // Fallback: wire buttons directly to Swiper.
//           if (this.selectors?.nextEl) {
//             this.selectors.nextEl.addEventListener('click', (e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               swiper.slideNext();
//             });
//           }
  
//           if (this.selectors?.prevEl) {
//             this.selectors.prevEl.addEventListener('click', (e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               swiper.slidePrev();
//             });
//           }
  
//           // Try to match "center video autoplay" immediately.
//           setTimeout(() => {
//             applySlideScale();
//             this.handleSlideChange(true);
//           }, 0);
//         }
  
//         handleSlideChange(isInit = false) {
//           if (!this.sliderInstance || !this.sliderInstance.slider) return;
  
//           const swiper = this.sliderInstance.slider;
//           const activeSlide = swiper.slides[swiper.activeIndex];
//           if (!activeSlide) return;
  
//           if (this.activeSlide === activeSlide && !isInit) return;
  
//           this.pauseAllExcept(activeSlide);
//           this.activeSlide = activeSlide;
//           this.activeVideo = activeSlide.querySelector('.video-reviews__video');
//           this.ensureVideoEvents(this.activeVideo);
//           this.updateSoundButtonState(activeSlide, this.activeVideo);
  
//           const activeIndex = Number(activeSlide.dataset.index);
//           const playRequested = this.playRequestedIndex !== null && this.playRequestedIndex === activeIndex;
//           const playManual = playRequested ? this.playRequestedManual : false;
  
//           if (this.autoplay || playRequested) {
//             this.playRequestedIndex = null;
//             this.playRequestedManual = false;
//             const manual = this.pendingManualSound ? true : playManual;
//             this.pendingManualSound = false;
//             this.playSlide(activeSlide, { manual });
//           } else {
//             // Keep the poster visible when autoplay is disabled.
//             activeSlide.classList.remove('is-playing');
//           }
//         }
  
//         pauseAllExcept(activeSlide) {
//           const allVideos = this.querySelectorAll('.video-reviews__video');
//           allVideos.forEach((video) => {
//             const slide = video.closest('.video-reviews__slide');
//             if (slide === activeSlide) return;
//             this.pauseVideo(video);
//           });
//         }
  
//         pauseSlide(slide) {
//           if (!slide) return;
  
//           const video = slide.querySelector('.video-reviews__video');
//           if (!video) return;
//           this.pauseVideo(video);
//         }
  
//         pauseVideo(video) {
//           if (!video) return;
//           const slide = video.closest('.video-reviews__slide');
//           slide && slide.classList.remove('is-playing');
//           video.muted = true;
//           if (slide) this.updateSoundButtonState(slide, video);
  
//           try {
//             if (!video.paused) video.pause();
//           } catch (e) {}
  
//           // Stop background buffering for inactive slides (best-effort).
//           const hls = video.__videoReviewsHls;
//           if (hls && typeof hls.stopLoad === 'function') {
//             try {
//               hls.stopLoad();
//             } catch (e) {}
//           }
//         }
  
//         ensureVideoEvents(video) {
//           if (!video || video.__videoReviewsEventsBound) return;
//           video.__videoReviewsEventsBound = true;
  
//           video.addEventListener('play', () => {
//             const slide = video.closest('.video-reviews__slide');
//             if (!slide) return;
//             slide.classList.add('is-playing');
//             this.updateSoundButtonState(slide, video);
//           });
  
//           video.addEventListener('pause', () => {
//             const slide = video.closest('.video-reviews__slide');
//             if (!slide) return;
//             slide.classList.remove('is-playing');
//             this.updateSoundButtonState(slide, video);
//           });
  
//           video.addEventListener('ended', () => {
//             // After center video ends, move to next slide.
//             if (!this.sliderInstance || !this.sliderInstance.slider) return;
  
//             const slide = video.closest('.video-reviews__slide');
//             if (!slide || slide !== this.activeSlide) return;
  
//             const swiper = this.sliderInstance.slider;
//             const total = this.slides.length;
//             if (!total) return;
  
//             const current = typeof swiper.realIndex === 'number' ? swiper.realIndex : Number(slide.dataset.index) || 0;
//             const next = (current + 1) % total;
//             swiper.slideToLoop(next);
//           });
//         }
  
//         async playSlide(slide, { manual = false } = {}) {
//           if (!slide) return;
  
//           const video = slide.querySelector('.video-reviews__video');
//           if (!video) return;
  
//           let hlsSrc = video.dataset.hlsSrc;
//           const mp4Src = video.dataset.mp4Src;
  
//           if (hlsSrc) hlsSrc = this.cleanM3U8Url(hlsSrc);
  
//           if (!hlsSrc && !mp4Src) {
//             slide.classList.remove('is-playing');
//             return;
//           }
  
//           // Avoid out-of-order async races when user swipes quickly.
//           const token = ++this.playToken;
  
//           this.pauseAllExcept(slide);
//           slide.classList.add('is-playing');
//           // Manual play always enables sound. Autoplay follows section setting.
//           video.muted = manual ? false : !this.autoplaySound;
//           // Safari is strict: autoplay works reliably only with muted + playsinline attributes present.
//           if (video.muted) {
//             video.setAttribute('muted', '');
//           } else {
//             video.removeAttribute('muted');
//           }
//           video.setAttribute('playsinline', '');
//           if (!manual) {
//             video.setAttribute('autoplay', '');
//           }
//           this.updateSoundButtonState(slide, video);
  
//           // If playback fails, revert the UI.
//           const revertUI = () => {
//             if (token !== this.playToken) return;
//             slide.classList.remove('is-playing');
//           };
//           video.addEventListener('error', revertUI, { once: true });
  
//           // If HLS isn't available, fall back to MP4.
//           if (!hlsSrc) {
//             if (!mp4Src) return;
//             try {
//               if (video.src !== mp4Src) {
//                 video.src = mp4Src;
//                 video.load();
//               }
//               await this.playWithSafariFallback(video, { manual, slide });
//             } catch (e) {}
//             return;
//           }
  
//           const isHlsNativelyPlayable = video.canPlayType('application/vnd.apple.mpegurl');
//           const shouldUseNativeHls = Boolean(hlsSrc) && (Boolean(isHlsNativelyPlayable) || this.isIOSDevice());
  
//           // Native HLS (Safari) case.
//           if (shouldUseNativeHls) {
//             if (video.src !== hlsSrc) {
//               video.src = hlsSrc;
//               try {
//                 video.load();
//               } catch (e) {}
//             }
  
//             try {
//               await this.playWithSafariFallback(video, { manual, slide });
//             } catch (e) {}
  
//             if (token !== this.playToken) return;
//             return;
//           }
  
//           // Other browsers: use hls.js (loaded on-demand).
//           if (typeof window.Hls === 'undefined') {
//             try {
//               await this.ensureHlsJsLoaded();
//             } catch (e) {
//               // hls.js failed to load; fallback to MP4 if available.
//               if (mp4Src) {
//                 try {
//                   if (video.src !== mp4Src) {
//                     video.src = mp4Src;
//                     video.load();
//                   }
//                   await this.playWithSafariFallback(video, { manual, slide });
//                 } catch (err) {}
//               }
//               return;
//             }
//           }
  
//           if (!window.Hls || typeof window.Hls.isSupported !== 'function' || !window.Hls.isSupported()) {
//             // MSE path unavailable (common on iOS). Try native src, then mp4.
//             if (hlsSrc) {
//               try {
//                 if (video.src !== hlsSrc) {
//                   video.src = hlsSrc;
//                   video.load();
//                 }
//                 await this.playWithSafariFallback(video, { manual, slide });
//                 return;
//               } catch (e) {}
//             }
//             if (mp4Src) {
//               try {
//                 if (video.src !== mp4Src) {
//                   video.src = mp4Src;
//                   video.load();
//                 }
//                 await this.playWithSafariFallback(video, { manual, slide });
//               } catch (e) {}
//             }
//             return;
//           }
  
//           if (!video.__videoReviewsHls) {
//             const hls = new window.Hls({
//               autoStartLoad: false,
//             });
  
//             video.__videoReviewsHls = hls;
  
//             hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
//               if (token !== this.playToken) return;
//               if (this.activeVideo !== video) return;
//               this.tryPlay(video, { manual, slide });
//             });
  
//             hls.loadSource(hlsSrc);
//             hls.attachMedia(video);
//           }
  
//           const hls = video.__videoReviewsHls;
//           if (hls && typeof hls.startLoad === 'function') {
//             try {
//               hls.startLoad();
//             } catch (e) {}
//           }
  
//           // Best-effort immediate attempt; it may still fail until manifest is parsed.
//           if (token !== this.playToken) return;
//           this.tryPlay(video, { manual, slide });
//         }
  
//         tryPlay(video, { manual = false, slide = null } = {}) {
//           if (!video) return;
//           try {
//             this.playWithSafariFallback(video, { manual, slide }).catch(() => {});
//           } catch (e) {}
//         }
  
//         async playWithSafariFallback(video, { manual = false, slide = null } = {}) {
//           if (!video) return;
  
//           try {
//             await video.play();
//             return;
//           } catch (err) {
//             // Safari can reject early; wait until it can play and retry.
//             await new Promise((resolve) => {
//               let settled = false;
//               const done = () => {
//                 if (settled) return;
//                 settled = true;
//                 resolve();
//               };
//               video.addEventListener('canplay', done, { once: true });
//               setTimeout(done, 350);
//             });
//           }
  
//           // Autoplay fallback: if unmuted autoplay is blocked, force muted retry.
//           if (!manual) {
//             video.muted = true;
//             video.setAttribute('muted', '');
//             if (slide) this.updateSoundButtonState(slide, video);
//           }
  
//           try {
//             await video.play();
//           } catch (err) {
//             // Keep silent; UI is already handled by caller's error/pause handlers.
//           }
//         }
  
//         ensureHlsJsLoaded() {
//           if (window.Hls) return Promise.resolve();
//           if (window.__videoReviewsHlsJsPromise) return window.__videoReviewsHlsJsPromise;
  
//           window.__videoReviewsHlsJsPromise = new Promise((resolve, reject) => {
//             const script = document.createElement('script');
//             script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
//             script.async = true;
//             script.onload = () => resolve();
//             script.onerror = () => reject(new Error('Failed to load hls.js'));
//             document.head.appendChild(script);
//           });
  
//           return window.__videoReviewsHlsJsPromise;
//         }
  
//         cleanM3U8Url(url) {
//           if (!url) return url;
//           // Remove cache-buster query params after ".m3u8" (e.g. ".m3u8?v=0").
//           // We intentionally drop everything after ".m3u8".
//           return url.replace(/(\.m3u8)(\?.*)$/i, '$1');
//         }
  
//         getSlideIndex(slide) {
//           if (!slide) return NaN;
//           // Swiper clones keep data-swiper-slide-index as canonical index.
//           const loopIndex = Number(slide.getAttribute('data-swiper-slide-index'));
//           if (!Number.isNaN(loopIndex)) return loopIndex;
//           return Number(slide.dataset.index);
//         }
  
//         updateSoundButtonState(slide, video) {
//           if (!slide || !video) return;
//           const btn = slide.querySelector('[data-action="toggle-sound"]');
//           if (!btn) return;
//           const unmuted = !video.muted;
//           btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
//           btn.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
//         }
  
//         isIOSDevice() {
//           const ua = window.navigator.userAgent || '';
//           const platform = window.navigator.platform || '';
//           const iOSLike = /iPhone|iPad|iPod/i.test(ua);
//           const iPadOS = platform === 'MacIntel' && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
//           return iOSLike || iPadOS;
//         }
//       }
//     );
//   }
if (!customElements.get('video-reviews-component')) {
    customElements.define(
      'video-reviews-component',
      class VideoReviewsComponent extends HTMLElement {
        constructor() {
          super();
  
          this.sliderInstance = false;
          this.activeSlide = null;
          this.activeVideo = null;
  
          this.playRequestedIndex = null;
          this.playRequestedManual = false;
          this.pendingManualSound = false;
          this.playToken = 0;
  
          this.sectionId = this.dataset.sectionId;
          this.section = this.closest(`.section-${this.sectionId}`);
  
          this.items = this.querySelector('.video-reviews__items');
          this.swiperEl = this.querySelector('.video-reviews__swiper');
          this.slides = Array.from(this.querySelectorAll('.video-reviews__slide'));
          this.videos = Array.from(this.querySelectorAll('.video-reviews__video'));
  
          this.enableSlider = this.dataset.enableSlider === 'true';
          this.autoplay = this.dataset.autoplay === 'true';
          this.autoplaySound = this.dataset.autoplaySound === 'true';
        }
  
        connectedCallback() {
          if (!this.section || !this.items) return;
  
          this.bindVideoEvents();
          this.bindUI();
  
          if (!this.enableSlider) {
            const firstSlide = this.slides[0];
            if (firstSlide && this.autoplay) {
              this.playSlide(firstSlide, { manual: false });
            }
            return;
          }
  
          this.selectors = {
            nextEl: this.section.querySelector('.swiper-btn-next'),
            prevEl: this.section.querySelector('.swiper-btn-prev'),
          };
  
          this.initSlider();
        }
  
        bindVideoEvents() {
          this.slides.forEach((slide) => {
            const video = slide.querySelector('.video-reviews__video');
            if (!video) return;
  
            // Keep UI in sync with real playback state.
            video.addEventListener('play', () => {
              slide.classList.add('is-playing');
            });
  
            video.addEventListener('pause', () => {
              slide.classList.remove('is-playing');
            });
          });
        }
  
        bindUI() {
          this.addEventListener('click', (event) => {
            const soundBtn = event.target.closest('[data-action="toggle-sound"]');
            if (soundBtn) {
              const slide = soundBtn.closest('.video-reviews__slide');
              if (!slide) return;
  
              const video = slide.querySelector('.video-reviews__video');
              if (!video) return;
  
              // Ensure clicked slide is center first, then toggle sound.
              if (this.sliderInstance && typeof this.sliderInstance.slider === 'object') {
                const index = this.getSlideIndex(slide);
                const isCurrentCenter = this.sliderInstance.slider.realIndex === index;
                if (!isCurrentCenter) {
                  this.playRequestedIndex = index;
                  this.playRequestedManual = true;
                  this.sliderInstance.slider.slideToLoop(index);
                  return;
                }
              }
  
              const nextMuted = !video.muted;
              video.muted = nextMuted;
              this.updateSoundButtonState(slide, video);
  
              if (video.paused) {
                this.playSlide(slide, { manual: true });
              }
              return;
            }
  
            const playBtn = event.target.closest('[data-action="play"]');
            if (!playBtn) return;
  
            const slide = playBtn.closest('.video-reviews__slide');
            if (!slide) return;
  
            const index = this.getSlideIndex(slide);
            if (Number.isNaN(index)) return;
  
            // Any play click is a "manual play": enable sound when playback starts.
            this.pendingManualSound = true;
  
            if (!this.sliderInstance || typeof this.sliderInstance.slider !== 'object') {
              this.playSlide(slide, { manual: true });
              return;
            }
  
            const swiper = this.sliderInstance.slider;
            const isCurrentCenter = typeof swiper.realIndex === 'number' && swiper.realIndex === index;
  
            // If it's already the active/center slide, toggle play/pause.
            if (isCurrentCenter) {
              const video = this.activeVideo || slide.querySelector('.video-reviews__video');
              if (!video) return;
  
              if (video.paused) {
                const centerSlide = swiper.slides[swiper.activeIndex] || slide;
                this.playSlide(centerSlide, { manual: true });
              } else {
                this.pauseVideo(video);
              }
              return;
            }
  
            // Click on side slide behaves like next/prev: move one step only.
            this.playRequestedIndex = null;
            this.playRequestedManual = true;
  
            if (slide.classList.contains('swiper-slide-next')) {
              swiper.slideNext();
              return;
            }
  
            if (slide.classList.contains('swiper-slide-prev')) {
              swiper.slidePrev();
              return;
            }
  
            // Fallback when classes are not yet updated: infer direction by position.
            const activeSlide = swiper.slides[swiper.activeIndex];
            if (!activeSlide) {
              swiper.slideToLoop(index);
              return;
            }
  
            const activeRect = activeSlide.getBoundingClientRect();
            const clickedRect = slide.getBoundingClientRect();
            const activeCenter = activeRect.left + activeRect.width / 2;
            const clickedCenter = clickedRect.left + clickedRect.width / 2;
  
            if (clickedCenter > activeCenter) {
              swiper.slideNext();
            } else {
              swiper.slidePrev();
            }
          });
        }
  
        initSlider() {
          if (!window.FoxTheme?.Carousel || !window.FoxTheme?.Swiper?.Swiper) return;
  
          const columnGap =
            typeof window.FoxTheme?.utils?.getGridColumnGap === 'function' ? window.FoxTheme.utils.getGridColumnGap(this.items) : null;
          const spaceBetween = columnGap?.desktop ? columnGap.desktop : 0;
  
          this.items.classList.add('swiper-wrapper');
          this.slides.forEach((slide) => slide.classList.add('swiper-slide'));
  
          const carouselContainer = this.swiperEl || this;
  
          this.sliderInstance = new window.FoxTheme.Carousel(carouselContainer, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            threshold: 2,
            grabCursor: true,
            allowTouchMove: true,
            spaceBetween: spaceBetween,
            watchSlidesProgress: true,
            pagination: false,
          });
  
          this.sliderInstance.init();
          const swiper = this.sliderInstance.slider;
  
          const applySlideScale = () => {
            if (!swiper?.slides) return;

            swiper.slides.forEach((slide) => {
              const progress = slide.progress || 0; // 0 = center, +/-1/2 etc.
              const absProgress = Math.abs(progress);

              let scale;
              if (absProgress < 0.5) {
                scale = 1;
              } else if (absProgress < 1.5) {
                scale = 0.9;
              } else if (absProgress < 2.5) {
                scale = 0.85;
              } else {
                scale = 0.8;
              }

              let translateX = 0;
              if (absProgress > 1.5 && absProgress < 2.5) {
                translateX = progress < 0 ? -40 : 40;
              } else if (absProgress > 0.5 && absProgress < 1.5) {
                translateX = progress < 0 ? -10 : 10;
              }

              // Swiper moves slides via wrapper transform; we only add subtle nudge + scale.
              // slide.style.transform = `translateX(${translateX}px) scale(${scale})`;
            });
          };

          swiper.on('progress', () => {
            if (swiper.animating) return;
            applySlideScale();
          });

          swiper.on('slideChangeTransitionEnd', () => {
            this.handleSlideChange();
            applySlideScale();
          });
          swiper.on('init', () => {
            applySlideScale();
            this.handleSlideChange(true);
          });
  
          // Fallback: wire buttons directly to Swiper.
          if (this.selectors?.nextEl) {
            this.selectors.nextEl.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              swiper.slideNext();
            });
          }
  
          if (this.selectors?.prevEl) {
            this.selectors.prevEl.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
              swiper.slidePrev();
            });
          }
  
          // Try to match "center video autoplay" immediately.
          setTimeout(() => {
            applySlideScale();
            this.handleSlideChange(true);
          }, 0);
        }
  
        handleSlideChange(isInit = false) {
          if (!this.sliderInstance || !this.sliderInstance.slider) return;
  
          const swiper = this.sliderInstance.slider;
          const activeSlide = swiper.slides[swiper.activeIndex];
          if (!activeSlide) return;
  
          if (this.activeSlide === activeSlide && !isInit) return;
  
          this.pauseAllExcept(activeSlide);
          this.activeSlide = activeSlide;
          this.activeVideo = activeSlide.querySelector('.video-reviews__video');
          this.ensureVideoEvents(this.activeVideo);
          this.updateSoundButtonState(activeSlide, this.activeVideo);
  
          const activeIndex = Number(activeSlide.dataset.index);
          const playRequested = this.playRequestedIndex !== null && this.playRequestedIndex === activeIndex;
          const playManual = playRequested ? this.playRequestedManual : false;
  
          if (this.autoplay || playRequested) {
            this.playRequestedIndex = null;
            this.playRequestedManual = false;
            const manual = this.pendingManualSound ? true : playManual;
            this.pendingManualSound = false;
            this.playSlide(activeSlide, { manual });
          } else {
            // Keep the poster visible when autoplay is disabled.
            activeSlide.classList.remove('is-playing');
          }
        }
  
        pauseAllExcept(activeSlide) {
          const allVideos = this.querySelectorAll('.video-reviews__video');
          allVideos.forEach((video) => {
            const slide = video.closest('.video-reviews__slide');
            if (slide === activeSlide) return;
            this.pauseVideo(video);
          });
        }
  
        pauseSlide(slide) {
          if (!slide) return;
  
          const video = slide.querySelector('.video-reviews__video');
          if (!video) return;
          this.pauseVideo(video);
        }
  
        pauseVideo(video) {
          if (!video) return;
          const slide = video.closest('.video-reviews__slide');
          slide && slide.classList.remove('is-playing');
          video.muted = true;
          if (slide) this.updateSoundButtonState(slide, video);
  
          try {
            if (!video.paused) video.pause();
          } catch (e) {}
  
          // Stop background buffering for inactive slides (best-effort).
          const hls = video.__videoReviewsHls;
          if (hls && typeof hls.stopLoad === 'function') {
            try {
              hls.stopLoad();
            } catch (e) {}
          }
        }
  
        ensureVideoEvents(video) {
          if (!video || video.__videoReviewsEventsBound) return;
          video.__videoReviewsEventsBound = true;
  
          video.addEventListener('play', () => {
            const slide = video.closest('.video-reviews__slide');
            if (!slide) return;
            slide.classList.add('is-playing');
            this.updateSoundButtonState(slide, video);
          });
  
          video.addEventListener('pause', () => {
            const slide = video.closest('.video-reviews__slide');
            if (!slide) return;
            slide.classList.remove('is-playing');
            this.updateSoundButtonState(slide, video);
          });
  
          video.addEventListener('ended', () => {
            // After center video ends, move to next slide.
            if (!this.sliderInstance || !this.sliderInstance.slider) return;
  
            const slide = video.closest('.video-reviews__slide');
            if (!slide || slide !== this.activeSlide) return;
  
            const swiper = this.sliderInstance.slider;
            const total = this.slides.length;
            if (!total) return;
  
            const current = typeof swiper.realIndex === 'number' ? swiper.realIndex : Number(slide.dataset.index) || 0;
            const next = (current + 1) % total;
            swiper.slideToLoop(next);
          });
        }
  
        async playSlide(slide, { manual = false } = {}) {
          if (!slide) return;
  
          const video = slide.querySelector('.video-reviews__video');
          if (!video) return;
  
          let hlsSrc = video.dataset.hlsSrc;
          const mp4Src = video.dataset.mp4Src;
  
          if (hlsSrc) hlsSrc = this.cleanM3U8Url(hlsSrc);
  
          if (!hlsSrc && !mp4Src) {
            slide.classList.remove('is-playing');
            return;
          }
  
          // Avoid out-of-order async races when user swipes quickly.
          const token = ++this.playToken;
  
          this.pauseAllExcept(slide);
          // REMOVED: slide.classList.add('is-playing'); - Don't show video yet, wait for actual play
          // Manual play always enables sound. Autoplay follows section setting.
          video.muted = manual ? false : !this.autoplaySound;
          // Safari is strict: autoplay works reliably only with muted + playsinline attributes present.
          if (video.muted) {
            video.setAttribute('muted', '');
          } else {
            video.removeAttribute('muted');
          }
          video.setAttribute('playsinline', '');
          if (!manual) {
            video.setAttribute('autoplay', '');
          }
          this.updateSoundButtonState(slide, video);
  
          // If playback fails, revert the UI.
          const revertUI = () => {
            if (token !== this.playToken) return;
            slide.classList.remove('is-playing');
          };
          video.addEventListener('error', revertUI, { once: true });
  
          // If HLS isn't available, fall back to MP4.
          if (!hlsSrc) {
            if (!mp4Src) return;
            try {
              if (video.src !== mp4Src) {
                video.src = mp4Src;
                video.load();
              }
              await this.playWithSafariFallback(video, { manual, slide });
            } catch (e) {}
            return;
          }
  
          const isHlsNativelyPlayable = video.canPlayType('application/vnd.apple.mpegurl');
          const shouldUseNativeHls = Boolean(hlsSrc) && (Boolean(isHlsNativelyPlayable) || this.isIOSDevice());
  
          // Native HLS (Safari) case.
          if (shouldUseNativeHls) {
            if (video.src !== hlsSrc) {
              video.src = hlsSrc;
              try {
                video.load();
              } catch (e) {}
            }
  
            try {
              await this.playWithSafariFallback(video, { manual, slide });
            } catch (e) {}
  
            if (token !== this.playToken) return;
            return;
          }
  
          // Other browsers: use hls.js (loaded on-demand).
          if (typeof window.Hls === 'undefined') {
            try {
              await this.ensureHlsJsLoaded();
            } catch (e) {
              // hls.js failed to load; fallback to MP4 if available.
              if (mp4Src) {
                try {
                  if (video.src !== mp4Src) {
                    video.src = mp4Src;
                    video.load();
                  }
                  await this.playWithSafariFallback(video, { manual, slide });
                } catch (err) {}
              }
              return;
            }
          }
  
          if (!window.Hls || typeof window.Hls.isSupported !== 'function' || !window.Hls.isSupported()) {
            // MSE path unavailable (common on iOS). Try native src, then mp4.
            if (hlsSrc) {
              try {
                if (video.src !== hlsSrc) {
                  video.src = hlsSrc;
                  video.load();
                }
                await this.playWithSafariFallback(video, { manual, slide });
                return;
              } catch (e) {}
            }
            if (mp4Src) {
              try {
                if (video.src !== mp4Src) {
                  video.src = mp4Src;
                  video.load();
                }
                await this.playWithSafariFallback(video, { manual, slide });
              } catch (e) {}
            }
            return;
          }
  
          if (!video.__videoReviewsHls) {
            const hls = new window.Hls({
              autoStartLoad: false,
            });
  
            video.__videoReviewsHls = hls;
  
            hls.on(window.Hls.Events.MANIFEST_PARSED, () => {
              if (token !== this.playToken) return;
              if (this.activeVideo !== video) return;
              this.tryPlay(video, { manual, slide });
            });
  
            hls.loadSource(hlsSrc);
            hls.attachMedia(video);
          }
  
          const hls = video.__videoReviewsHls;
          if (hls && typeof hls.startLoad === 'function') {
            try {
              hls.startLoad();
            } catch (e) {}
          }
  
          // Best-effort immediate attempt; it may still fail until manifest is parsed.
          if (token !== this.playToken) return;
          this.tryPlay(video, { manual, slide });
        }
  
        tryPlay(video, { manual = false, slide = null } = {}) {
          if (!video) return;
          try {
            this.playWithSafariFallback(video, { manual, slide }).catch(() => {});
          } catch (e) {}
        }
  
        async playWithSafariFallback(video, { manual = false, slide = null } = {}) {
          if (!video) return;
  
          try {
            await video.play();
            return;
          } catch (err) {
            // Safari can reject early; wait until it can play and retry.
            await new Promise((resolve) => {
              let settled = false;
              const done = () => {
                if (settled) return;
                settled = true;
                resolve();
              };
              video.addEventListener('canplay', done, { once: true });
              setTimeout(done, 350);
            });
          }
  
          // Autoplay fallback: if unmuted autoplay is blocked, force muted retry.
          if (!manual) {
            video.muted = true;
            video.setAttribute('muted', '');
            if (slide) this.updateSoundButtonState(slide, video);
          }
  
          try {
            await video.play();
          } catch (err) {
            // Keep silent; UI is already handled by caller's error/pause handlers.
          }
        }
  
        ensureHlsJsLoaded() {
          if (window.Hls) return Promise.resolve();
          if (window.__videoReviewsHlsJsPromise) return window.__videoReviewsHlsJsPromise;
  
          window.__videoReviewsHlsJsPromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://cdn.jsdelivr.net/npm/hls.js@1/dist/hls.min.js';
            script.async = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error('Failed to load hls.js'));
            document.head.appendChild(script);
          });
  
          return window.__videoReviewsHlsJsPromise;
        }
  
        cleanM3U8Url(url) {
          if (!url) return url;
          // Remove cache-buster query params after ".m3u8" (e.g. ".m3u8?v=0").
          // We intentionally drop everything after ".m3u8".
          return url.replace(/(\.m3u8)(\?.*)$/i, '$1');
        }
  
        getSlideIndex(slide) {
          if (!slide) return NaN;
          // Swiper clones keep data-swiper-slide-index as canonical index.
          const loopIndex = Number(slide.getAttribute('data-swiper-slide-index'));
          if (!Number.isNaN(loopIndex)) return loopIndex;
          return Number(slide.dataset.index);
        }
  
        updateSoundButtonState(slide, video) {
          if (!slide || !video) return;
          const btn = slide.querySelector('[data-action="toggle-sound"]');
          if (!btn) return;
          const unmuted = !video.muted;
          btn.setAttribute('aria-pressed', unmuted ? 'true' : 'false');
          btn.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
        }
  
        isIOSDevice() {
          const ua = window.navigator.userAgent || '';
          const platform = window.navigator.platform || '';
          const iOSLike = /iPhone|iPad|iPod/i.test(ua);
          const iPadOS = platform === 'MacIntel' && typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1;
          return iOSLike || iPadOS;
        }
      }
    );
  }